<template>
  <v-data-table
    v-model="selected"
    :items="sellers"
    :headers="productDataHeader"
    hide-default-footer
    hide-default-header
    item-key="seller_name"
    class="ex-data-table"
    >
      <template v-slot:header="{ props: { headers } }">
        <thead>
        <tr>
          <th v-for="h in headers" :key="`${h.value}-${productUrlId}`" :class="h.class">
            <span>{{h.text}}</span>
          </th>
        </tr>
        </thead>
      </template>
      <template v-slot:item="{item, index}">
        <tr class="product_row_title">
          <td>
            <div class="product_row_cell">
              <div
                :style="{
                  background: item['color_code'] ? item['color_code'] : 'unset',
                  color: item['color_code'] ? item['color_code'] : 'transparent'
                }"
                class="variation_color">&nbsp;
              </div>
            </div>
          </td>
          <td>
            <div class="product_row_cell">
              <span class="ex-data-table__link">
                {{ item.seller_name || '_' }}
              </span>
            </div>
          </td>
          <td>
            <div class="product_row_cell">
              <span class="ex-data-table__link">
                {{ getPrice(item['tracks_properties'])['property_value'] || '_' }}
              </span>
            </div>
          </td>
          <td>
            <div class="product_row_cell">
              <span class="ex-data-table__link">
                {{ getPrice(item['tracks_properties'])['renewed'] || '_' }}
              </span>
            </div>
          </td>
          <td>
            <div class="product_row_cell">
              <span class="ex-data-table__link">
                {{ getAvailability(item['tracks_properties'])['property_value'] || '_' }}
              </span>
            </div>
          </td>
          <td>
            <div class="product_row_cell">
              <span class="ex-data-table__link">
                {{ getAvailability(item['tracks_properties'])['renewed'] || '_' }}
              </span>
            </div>
          </td>
          <td>
            <div class="product_row_cell">
              <span class="ex-data-table__link">
                {{ getShipping(item['tracks_properties'])['property_value'] || '_' }}
              </span>
            </div>
          </td>
          <td>
            <div class="product_row_cell">
              <span class="ex-data-table__link">
                {{ getShipping(item['tracks_properties'])['renewed'] || '_' }}
              </span>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
</template>

<script>
import Table from './Table'

export default {
  name: 'ProductDetailsTableSellers',
  components: {Table},
  props: {
    selected: {
      type: Array,
      default: null
    },
    sellers: {
      type: [Object, Array],
      default: null
    },
    productUrlId: {
      type: Number,
      default: null,
      required: true
    }
  },
  data: () => ({
    productDataHeader: [
      {
        text: '#',
        align: 'left',
        sortable: false,
        class: 'tableHeaderClass',
        value: 'index'
      },
      {
        text: 'Seller',
        align: 'left',
        sortable: false,
        class: 'tableHeaderClass',
        value: 'seller'
      },
      {
        text: 'Price',
        align: 'left',
        sortable: false,
        class: 'tableHeaderClass',
        value: 'price'
      },
      {
        text: 'Renewed',
        align: 'left',
        sortable: false,
        class: 'tableHeaderClass',
        value: 'renewed'
      },
      {
        text: 'Availability',
        align: 'left',
        sortable: false,
        class: 'tableHeaderClass',
        value: 'availability'
      },
      {
        text: 'Renewed',
        align: 'left',
        sortable: false,
        class: 'tableHeaderClass',
        value: 'renewed2'
      },
      {
        text: 'Shipping',
        align: 'left',
        sortable: false,
        class: 'tableHeaderClass',
        value: 'shipping'
      }
    ]
  }),
  methods: {
    getPrice: properties => properties.find((property) => property['property_id'] === 5) || {
      property_value: '',
      renewed: ''
    },
    getAvailability: properties => properties.find((property) => property['property_id'] === 8) || {
      property_value: '',
      renewed: ''
    },
    getShipping: properties => properties.find((property) => property['property_id'] === 9) || {
      property_value: '',
      renewed: ''
    }
  }
}
</script>

<style scoped>
.total-product-data-table table > tbody > tr > td {
  padding-top: 15px !important;
}
.v-expansion-panel-header {
  padding: 16px 14px;
}
.product_row_cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
}

table tr td {
  position: relative;
}

.variation_color {
  width: 20px;
  height: 20px;
  margin: 0;
  border-radius: 5px;
}

.tableHeaderClass span{
  font-weight: 300;
  color: #9899ac;
  font-size: 14px;
  display: block;
  margin-top: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/product/ProductDetailsTableSellers.vue